<template>
  <div>
    <!-- edit profile dialog -->
    <v-dialog
      v-model="isInfoDialogOpen"
      max-width="650px"
      @click:outside="$emit('update:is-info-dialog-open',false)"
    >
      <v-card class="pa-sm-10 pa-3">
        <v-card-title class="justify-center text-h5">
          Editar informações de Fila
        </v-card-title>

        <v-card-text class="mt-5">
          <v-form
            ref="form"
            v-model="valid"
            class="multi-col-validation"
            @submit.prevent="update()"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="filaDataLocale.nome"
                  outlined
                  dense
                  label="Nome"
                  :rules="[validators.required]"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-textarea
                  v-model="filaDataLocale.descricao"
                  outlined
                  dense
                  label="Descrição"
                  hint="Máximo de 300 caracteres"
                  auto-grow
                ></v-textarea>
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-select
                  v-model="filaDataLocale.maxTicketsPorAgente"
                  outlined
                  dense
                  label="Quantidade máxima de ticket por agente."
                  :items="QtdTicket"
                  hide-details="auto"
                  :rules="[validators.select]"
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-checkbox
                  v-model="filaDataLocale.isAgrupado"
                  label="Agrupar tickets desta fila?"
                ></v-checkbox>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-checkbox
                  v-model="filaDataLocale.permitirAgendamento"
                  label="Permitir agendamento?"
                ></v-checkbox>
              </v-col>

              <v-col
                cols="12"
                class="d-flex justify-center mt-3"
              >
                <v-btn
                  color="primary"
                  class="me-3"
                  type="submit"
                >
                  <v-progress-circular
                    v-if="loadings"
                    class="mx-6"
                    indeterminate
                    color="secundary"
                  ></v-progress-circular>
                  <span v-else> Confirmar </span>
                </v-btn>

                <v-btn
                  outlined
                  color="secondary"
                  @click.prevent="$emit('update:isInfoDialogOpen', false)"
                >
                  Descartar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, select } from '@core/utils/validation'
import { ref, watch } from '@vue/composition-api'
import router from '@/router'
import FilaService from '@/services/modules/FilaService'

export default {
  props: {
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
    filaData: {
      type: Object,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const QtdTicket = [
      5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135,
      140, 145, 150,
    ]

    const status = [
      { title: 'Ativo', value: 2 },
      { title: 'Inativo', value: 3 },
    ]
    const filaDataLocale = ref(JSON.parse(JSON.stringify(props.filaData)))
    const loadings = ref(false)
    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      filaDataLocale.value = JSON.parse(JSON.stringify(props.filaData))
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        filaDataLocale.value = JSON.parse(JSON.stringify(props.filaData))
      },
    )

    const update = async () => {
      if (valid.value) {
        try {
          loadings.value = !loadings.value

          await FilaService.update(router.currentRoute.params.id, filaDataLocale.value)

          emit('refetch-data')
          emit('update:is-info-dialog-open', false)
          loadings.value = !loadings.value
        } catch {
          loadings.value = !loadings.value
        }
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetForm,
      form,
      valid,
      QtdTicket,
      status,
      filaDataLocale,
      loadings,
      update,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
